import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import type { SearchDto, SearchGroup } from '@cw/shared';
import { api } from './api';

export const SEARCH_LABELS: Record<SearchGroup, string> = {
  projects: 'Projetos',
  clients: 'Clientes',
  tasks: 'Tarefas',
  files: 'Arquivos',
  boards: 'Boards e moodboards',
  storyboards: 'Storyboards',
  notes: 'Notas',
  comments: 'Comentários',
  invoices: 'Faturas',
};

/** Busca com espera curta entre teclas (não consulta a cada letra). */
export function useSearch(q: string, only?: SearchGroup) {
  const [term, setTerm] = useState(q);
  useEffect(() => {
    const t = setTimeout(() => setTerm(q.trim()), 180);
    return () => clearTimeout(t);
  }, [q]);
  return useQuery({
    queryKey: ['search', term, only ?? 'all'],
    queryFn: () => api.get<SearchDto>(`/search?q=${encodeURIComponent(term)}${only ? `&only=${only}` : ''}`),
    enabled: term.length >= 2,
    placeholderData: (prev) => prev,
    staleTime: 15_000,
  });
}

/** Abre um resultado: "?task=" abre a tarefa por cima da tela atual. */
export function hrefFor(href: string): string {
  return href.startsWith('?') ? `${window.location.pathname}${href}` : href;
}
